import { Component } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { ActivatedRoute } from '@angular/router';
import { ProjectsComponent } from 'src/app/shared/modules/projects/projects.component';
import { EModules } from 'src/app/app.enum';

@Component({
  selector: 'app-checkin',
  templateUrl: '../../../shared/layouts/sidebar-layout/sidebar-layout.component.html',
  styleUrls: [
    '../../../shared/layouts/sidebar-layout/sidebar-layout.component.scss',
    './checkin.component.scss'
  ]
})
export class CheckinComponent extends ProjectsComponent {
  constructor(public activatedRoute: ActivatedRoute, public config: ConfigService) {
    super(activatedRoute, config);
    (this.config.company.isEnabledModule(EModules.INBOX)) && this.setWebSocket();
  }
}
